import styled from "styled-components";
import { Grid, theme } from "@finvia/money-ui";

export const SelectFieldsContainer = styled(Grid)`
  margin-top: ${theme.tokens.sizes.spacings.mega};
  align-items: flex-end;
`;
